<!--
 * @Author: your name
 * @Date: 2020-10-09 17:49:08
 * @LastEditTime: 2020-11-26 10:31:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \project\src\views\Home\Member\children\Product.vue
-->
<template>
  <div class="popContainer">
    <div id='product'>
      <img src="@/assets/img/火箭.png" alt="">
      <p>系统升级中</p>

    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  }
}
</script>
<style lang='less' scoped>
#product {
  padding: 0 25px;
  text-align: center;
  margin: 10% 0;
  font-size: 15px;
}
.popContainer {
  // position: fixed;
  // top: 31%;
  // left: 4%;
  // right: 22.3%;
  // bottom: 0;
  // z-index: 999;
  // background: rgba(255, 255, 255, 0.3);
}
</style>